import { Component, input } from '@angular/core';
import { CommunityProfile } from '../../../utils/profile.utils';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DataTestDirective } from '@outlaw/core';
import { LineBreakToHtmlPipe } from '../../../pipes/line-break-to-html.pipe';

@Component({
  selector: 'app-profile-data',
  templateUrl: './profile-data.component.html',
  styleUrls: ['./profile-data.component.scss'],
  imports: [NgxSkeletonLoaderModule, DataTestDirective, LineBreakToHtmlPipe],
})
export class ProfileDataComponent {
  profile = input<CommunityProfile>();
  isLoading = input<boolean>(false);
}
